export function getBasePath() {
  let basename = '/';

  if (process.env.NODE_ENV !== 'development') {
    basename = '/';
  }
  return basename;
}
